// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderAccount: React.FC<{ width?: number; height?: number }> = ({ width = 22, height = 22 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 22 22">
            <path
                fill="currentColor"
                d="M17.488 17.188c-.86-2.02-2.793-3.438-5.113-3.438h-2.75c-2.277 0-4.254 1.418-5.07 3.438C3.008 15.555 2.063 13.406 2.063 11A8.93 8.93 0 0 1 11 2.063 8.93 8.93 0 0 1 19.938 11c0 2.406-.946 4.555-2.45 6.188m-1.761 1.375c-1.375.859-2.965 1.375-4.727 1.375s-3.352-.516-4.727-1.375a3.42 3.42 0 0 1 3.352-2.75h2.75c1.676 0 3.05 1.203 3.395 2.75zM11 22c6.059 0 11-4.941 11-11S17.059 0 11 0 0 4.941 0 11s4.941 11 11 11m0-11.687a1.724 1.724 0 0 1-1.719-1.72c0-.945.774-1.718 1.719-1.718s1.719.773 1.719 1.719c0 .945-.774 1.719-1.719 1.719m-3.781-1.72A3.76 3.76 0 0 0 11 12.376a3.76 3.76 0 0 0 3.781-3.781A3.76 3.76 0 0 0 11 4.813a3.76 3.76 0 0 0-3.781 3.78"
            />
        </svg>
    );
};

export default React.memo(HeaderAccount);
